import { useState, useCallback } from 'react'

// Custom hook to manage tooltip state and mouse tracking with CSS-only animations
export const useTooltip = () => {
  const [tooltip, setTooltip] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

  // Show tooltip with data
  const showTooltip = useCallback((data, event) => {
    // Handle both regular mouse events and SVG events
    const x = event.clientX || event.pageX || 0
    const y = event.clientY || event.pageY || 0
    setMousePosition({ x, y })
    setTooltip(data)
    setIsVisible(true)
  }, [])

  // Hide tooltip
  const hideTooltip = useCallback(() => {
    setIsVisible(false)
  }, [])

  // Update mouse position while tooltip is visible
  const updateMousePosition = useCallback(
    event => {
      if (tooltip) {
        const x = event.clientX || event.pageX || 0
        const y = event.clientY || event.pageY || 0
        setMousePosition({ x, y })
      }
    },
    [tooltip]
  )

  return {
    tooltip,
    isVisible,
    mousePosition,
    showTooltip,
    hideTooltip,
    updateMousePosition
  }
}
